// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * This component is loaded when the Azure implicit grant flow has completed.
 */
class ClosePopup extends React.Component {

    componentDidMount(){

      microsoftTeams.initialize();

      //The Azure implicit grant flow injects the result into the window.location.hash object. Parse it to find the results.
      let hashParams = this.getHashParameters();
      
      if (hashParams["error"]) {
        // Authentication/authorization failed
        microsoftTeams.authentication.notifyFailure(hashParams["error"]);
      } else if (hashParams["access_token"]) {
        // Get the stored state parameter and compare with incoming state
        // This validates that the data is coming from Azure AD
        let expectedState = localStorage.getItem("cws.state");
        if (expectedState !== hashParams["state"]) {
          // State does not match, report error
          microsoftTeams.authentication.notifyFailure("StateDoesNotMatch");
        } else {
          // Success: return token information to the tab
          microsoftTeams.authentication.notifySuccess({
            idToken: hashParams["id_token"],
            accessToken: hashParams["access_token"],
            tokenType: hashParams["token_type"],
            expiresIn: hashParams["expires_in"]
          })
        }
      } else {
        // Unexpected condition: hash does not contain error or access_token parameter
        microsoftTeams.authentication.notifyFailure("UnexpectedFailure");
      }
    }

    //Helper function that converts window.location.hash into a dictionary
    getHashParameters() {
      let hashParams = {};
      window.location.hash.substr(1).split("&").forEach(function(item) {
        let [key,value] = item.split('=');
        hashParams[key] = decodeURIComponent(value);
      });
      return hashParams;
  }    

    render() {
      return (
        <div>
          <h1>Permessi concessi correttamente</h1>
        </div>
      );
    }
}

export default ClosePopup;